import React from 'react'
import { Routes, Route, useNavigate, useParams } from 'react-router-dom'
import { useNavigate, useParams } from 'react-router-dom'

import CircularProgress from '@mui/material/CircularProgress'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import { DataGrid } from '@mui/x-data-grid'
import FormControlLabel from '@mui/material/FormControlLabel'
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'

import useStateObject from '~/client/hooks/useStateObject'
import { useQuery, useCommand } from '~/client/hooks/cqrpc'
import useToggle from '~/client/hooks/useToggle'

import Link from '~/client/components/Link'
import Heading from '~/client/components/Heading'
import Loading from '~/client/components/Loading'
import ButtonRow from '~/client/components/ButtonRow'
import ErrorMessage from '~/client/components/ErrorMessage'
import DocumentTypeCreateForm from '~/client/components/DocumentTypeCreateForm'
import Timestamp from '~/client/components/Timestamp'
import LoadingList from '~/client/components/LoadingList'
import DocumentTypeFormPreview from '~/client/components/DocumentTypeFormPreview'
import InspectObject from '~/client/components/InspectObject'

export default function JSONEditor({ value, onChange, ...props }){
  const [isValid, setValid] = React.useState(true)
  const [json, setJson] = React.useState(
    toJSON(value)
  )
  return <TextField
    label="UI Schema"
    multiline
    fullWidth
    {...props}
    value={json}
    sx={{
      '& textarea': {
        fontFamily: 'monospace',
        fontSize: 'smaller',
      },
      ...props.sx
    }}
    onChange={event => {
      const json = event.target.value
      setJson(json)
      let value, valid
      try{ value = JSON.parse(json); valid = true }
      catch(error){}
      setValid(valid)
      if (valid) onChange(value)
    }}
    error={!isValid}
    helperText={isValid ? <span>JSON Invalid</span> : undefined}
  />
}

const toJSON = value => {
  if (typeof value === 'string') value= JSON.parse(value)
  return JSON.stringify(value, null, 2)
}
